// src/pages/Step2.js
import React from "react";
import styled from "styled-components";
import { Container, Card } from "../components/Layout";
import ProgressButton from "../components/ProgressButton";

const ResultMessage = styled.p`
  font-size: 16px;
  margin: 10px 0;
  color: ${({ theme }) => theme.colors.text};
`;

function Step2({ bmi, ethnicity, onNext, onSkipStep3, onBack }) {
  const getMessage = () => {
    if (bmi < 18.5) {
      return "Du er undervægtig. Det anbefales at tale med en læge om din vægt.";
    }
    if (bmi >= 18.5 && bmi <= 24.9) {
      return "Din vægt er normal.";
    }
    if (bmi >= 25 && bmi <= 29.9) {
      return "Du er overvægtig.";
    }
    if (bmi >= 30) {
      return "Du er i kategorien fedme. Behandling anbefales.";
    }

    if (ethnicity === "Hvid") {
      if (bmi >= 30) {
        return "Du opfylder kravet for BMI > 30. Behandling er anbefalet.";
      }
      if (bmi >= 27 && bmi < 30) {
        return "Du ligger i kategorien overvægt, som ikke i sig selv er en indikation for behandling med vægttabsmedicin.";
      }
      return "Du opfylder ikke kravene for medicinsk vægttab.";
    } else {
      if (bmi > 27.5) {
        return "Du opfylder kravet for fedme (BMI > 27,5). Behandling er anbefalet.";
      }
      if (bmi >= 23 && bmi <= 27.4) {
        return "Du ligger i kategorien overvægt (BMI 23-27,4). Behandling er anbefalet, hvis der er en følgetilstand.";
      }
      return "Du opfylder ikke kravene for medicinsk vægttab.";
    }
  };

  const handleNext = () => {
    const isWhite = ethnicity === "Hvid";
    if ((isWhite && bmi >= 30) || (!isWhite && bmi > 27.5)) {
      onSkipStep3();
    } else {
      onNext();
    }
  };

  const shouldHideNextButton = () => {
    const isWhite = ethnicity === "Hvid";
    return (isWhite && bmi < 27) || (!isWhite && bmi < 23);
  };

  return (
    <Container>
      <Card>
        <h1>Dit bmi resultat</h1>
        <ResultMessage>BMI: {bmi}</ResultMessage>
        <ResultMessage>{getMessage()}</ResultMessage>
        <div>
          <ProgressButton text="Tilbage" onClick={onBack} />
          {!shouldHideNextButton() && (
            <ProgressButton text="Videre" onClick={handleNext} />
          )}
        </div>
      </Card>
    </Container>
  );
}

export default Step2;
